// https://www.npmjs.com/package/js-cookie
import Cookies from 'js-cookie'

export const accessTokenCookieName = 'accessToken';

function accessTokenCookieOptions(): any {
    return {
        expires: 365,
        path: '/',
        sameSite: 'lax',
        // The token remains readable by the current SPA because it constructs
        // Authorization headers itself.  HTTPS environments must not send it
        // over HTTP; localhost remains usable for local development.
        secure: window.location.protocol === 'https:',
    };
}

export function setAccessTokenCookie(accessToken:any):void {
    //    accessToken is actually a string but TS doesn't compile it for some reason.
    Cookies.set(accessTokenCookieName, accessToken, accessTokenCookieOptions());
}

export function getAccessTokenCookie():string | undefined {
    return Cookies.get(accessTokenCookieName);
}

export function removeAccessTokenCookie():void {
    return Cookies.remove(accessTokenCookieName, { path: '/' });
}
